var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OfficeLayout',[_c('SpaceSettingsNav'),_c('transition',{attrs:{"name":"router-anim"}},[(!_vm.current_space.dirty)?_c('router-view'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }